import React from 'react'
import Radio from '@mui/material/Radio';
import RadioGroupMui from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const RadioGroup = ({options=[], groupTitle="", defaultRadioValue}) => {

  const handleChange = (e) => {
    // use 'e.target.value' to access the value
  }

  return (
    <FormControl>
    <FormLabel >{groupTitle}</FormLabel>
    <RadioGroupMui
      defaultValue={defaultRadioValue}
      onChange={handleChange}
    >
        {options.map((opt, index) => <FormControlLabel 
        key={index}
        value={opt.value} 
        control={ <Radio 
                      sx={{
                        color: "black",
                        '&.Mui-checked': {
                          color: "black",
                        },
                      }}
                  />} label={opt.label} />)}
    </RadioGroupMui>
  </FormControl>
  )
}

export default RadioGroup;
